<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <button routerLink="/backoffice/configuration/collection-albums" [queryParams]="{ id: collectionId }" class="btn btn-sm btn-primary"><i class="fa fa-chevron-left"></i> Back</button>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-clone"></i> Cards
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
              <i class="fa fa-plus"></i> Add Card
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline align-middle mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Image</th>
                <th>Name</th>
                <th>Rank</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="7" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else if (cards.length === 0) {
                <tr>
                  <td colspan="7" class="text-center text-muted">No card found.</td>
                </tr>
              } @else {
                @for (card of cards; track card.cardId; let i = $index) {
                  <tr>
                    <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                    <td>{{ card.cardId }}</td>
                    <td>
                      @if (hasImage(card)) {
                        <img [src]="getImageUrl(card)" alt="" style="max-height: 48px; max-width: 64px; object-fit: contain;">
                      } @else {
                        <span class="text-muted">-</span>
                      }
                    </td>
                    <td>{{ card.name }}</td>
                    <td>{{ CollectionCardRankType[card.rankType] }}</td>
                    <td>
                      @if (!hasImage(card)) {
                        <span class="badge bg-danger me-1">Image missing</span>
                      }
                      @if (getMissingTranslationsCount(card) > 0) {
                        <span class="badge bg-danger">{{ getMissingTranslationsCount(card) }} translations missing</span>
                      }
                    </td>
                    <td>
                      <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEdit(card)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                      <button class="btn btn-sm btn-info me-1" type="button" [disabled]="uploadingImageId === card.cardId" (click)="onClickUploadImage(card)" tooltip="Upload image (PNG, 2 MB max)" placement="top">
                        @if (uploadingImageId === card.cardId) { <span class="spinner-border spinner-border-sm"></span> } @else { <i class="fa fa-upload"></i> }
                      </button>
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(card)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + cards.length }} of {{ totalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === pageNumber">
                    <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="pageNumber >= totalPages">
                <button class="page-link" (click)="onClickPaginationNext()" [disabled]="pageNumber >= totalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<input #imageInput type="file" accept="image/png" style="display:none" (change)="onImageSelected($event)">

<app-collection-card-add-modal #addModal [albumId]="albumId"></app-collection-card-add-modal>
<app-collection-card-edit-modal #editModal [albumId]="albumId"></app-collection-card-edit-modal>
